export function filterAccordion() {
    const filterToggle = document.querySelector('.c-portfolio__filter-toggle');
    const filterMenu = document.querySelector('.c-portfolio__filter-menu');
    
    if (!filterToggle || !filterMenu) return;
    
    // アコーディオンの開閉
    filterToggle.addEventListener('click', function() {
        const isActive = this.classList.contains('is-active');
        
        if (isActive) {
            // 閉じる
            this.classList.remove('is-active');
            filterMenu.classList.remove('is-open');
        } else {
            // 開く
            this.classList.add('is-active');
            filterMenu.classList.add('is-open');
        }
    });
    
    // フィルターメニュー外をクリックした時に閉じる
    document.addEventListener('click', function(event) {
        const filterContainer = document.querySelector('.c-portfolio__filter');
        
        if (filterContainer && !filterContainer.contains(event.target)) {
            filterToggle.classList.remove('is-active');
            filterMenu.classList.remove('is-open');
        }
    });
    
    // ウィンドウリサイズ時の処理
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768) {
            // デスクトップ表示時はアコーディオンをリセット
            filterToggle.classList.remove('is-active');
            filterMenu.classList.remove('is-open');
        }
    });
} 